<!-- eslint-disable vue/multi-word-component-names -->
<template>

    <div class="image-container">
        <img src="./images/20211014_085847.jpg" class="hero-image">
        <div class="image-overlay">
            <h1>Your Partner in Construction Safety Excellence</h1>
            <p>
                With 25 years of industry experience, IC Safety Solutions provides comprehensive safety programs,
                gas monitor calibration and repair,
                and specialized training to protect your most valuable assets - your people.
            </p>
            <router-link to="/services"><button class="services-button">Our Services</button></router-link>
            <router-link to="/contact"><button class="contact-button">Get In Touch</button></router-link>
        </div>

    </div>
    <div class="header-statement">
        <h3>Our Comprehensive Services</h3>
        <p>From safety program development to specialized training, we offer end-to-end solutions for your construction
            safety needs.</p>
    </div>

    <div class="grid-container">
        <div class="item1 services-box">
            <img src="./images/SH.jpg" alt="Hard Hat Logo" class="services-logo">
            <h3> Industry Expertise </h3>
            <p>Specialized knowledge in construction and industrial safety regulations.
            </p>
        </div>
        <div class="item2 services-box">
            <img src="./images/CL.jpg" alt="Check List Logo" class="services-logo">
            <h3> Comprehensive Programs </h3>
            <p>Tailored safety policies and procedures to meet your specific needs.</p>
        </div>
        <div class="item3 services-box">
            <img src="./images/TR.jpg" alt="Training Room Logo" class="services-logo">
            <h3> Expert Training </h3>
            <p>Specialized instruction in critical safety procedures and protocols.</p>
        </div>
        <div class="item4 services-box">
            <img src="./images/MG.jpg" alt="Magnifying Glass Logo" class="services-logo">
            <h3> Gas Monitor Calibration </h3>
            <p>Gas monitor storage, repair, and calibration services. </p>
        </div>
    </div>
    <div class="grid-container-2">
        <div class="item1">
            <img src="./images/Energy-Wheel_Revised_SimplifiedLayers.jpg" class="ewstky-img">
        </div>
        <div class="item2 ewstky-desc">
            <h3>Why we use the energy wheel:</h3>
            <p>By categorizing hazards into energy types
                (mechanical, thermal, chemical, etc.), the Safety Energy
                Wheel ensures every potential source of harm is identified and reviewed for each step of a task.
                Once an energy hazard is flagged, teams can map it directly to the hierarchy of controls—elimination,
                engineering controls, administrative procedures, or PPE—to create clear, actionable safety measures.
                This common framework standardizes communication, simplifies audits, and drives continuous improvement
                in jobsite safety planning.</p>
        </div>

    </div>



</template>
<script>
export default {}
</script>
<style>
.image-container {
    display: inline-block;
    width: 100%;
    height: 55vh;
    overflow: hidden;
    position: relative;
}

.hero-image {
    width: 100%;
    height: 100%;
    object-position: 0% 66%;
    object-fit: cover;
}

.image-overlay {
    position: absolute;
    margin-left: 13vw;
    top: 10%;
    text-align: left;
    color: white;
    max-width: 50%;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
    font-family: ui-sans-serif, system-ui, sans-serif;
}

.image-overlay h1 {
    font-size: 120%;
}

.image-overlay p {
    font-size: 80%;
}

.services-button {
    background-color: rgb(245, 122, 34);
    padding: 2% 4%;
    margin-right: 2%;
    border-radius: 4px;
    border: none;
    color: white;
    font-size: 80%;
}

.contact-button {
    padding: 2% 4%;
    border-radius: 4px;
    border: none;
    color: black;
    margin: 3% 0%;
    font-size: 80%;
}

.header-statement {
    text-align: center;
    margin-top: 3%;
    font-family: ui-sans-serif, system-ui, sans-serif;
}

.header-statement h3 {
    font-size: 120%;
}

.header-statement p {
    font-size: 80%;
}

.services-box {
    text-align: center;
    box-shadow: 0px 5px 5px 2px rgba(0, 0, 0, .2);
    border-radius: 6px;
}

.services-box h3 {
    font-size: 80%;
}

.services-box p {
    font-size: 60%;
}

.services-logo {
    transform: scale(.5);
    padding: 1em 0em;
}

.grid-container {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 10px;
    padding: 10px;
    margin: 5% 5vw;
}

.grid-container-2 {
    display: grid;
    grid-template-columns: auto;
    grid-gap: 1%;
    padding: 5px;
    width: 70vw;
    margin: 2% 13vw;
}

.ewstky-img {
    width: 70vw;
}

.ewstky-desc {
    width: 70vw;
    text-align: center;
    margin-top: 5%;
}

.ewstky-desc h3 {
    font-size: 120%;
    color: #0e5295;
}

.ewstky-desc p {
    font-size: 80%;
    width: 75%;
    margin-left: 12%;
}

@media (min-width:640px) {
    .image-container {
        display: inline-block;
        width: 100%;
        height: 65vh;
        overflow: hidden;
        position: relative;
    }

    .hero-image {
        width: 100%;
        height: 100%;
        object-position: 0% 66%;
        object-fit: cover;
    }

    .image-overlay {
        position: absolute;
        margin-left: 13vw;
        top: 25%;
        text-align: left;
        color: white;
        max-width: 30%;
        padding: 0.5rem 1rem;
        border-radius: 0.5rem;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
        font-family: ui-sans-serif, system-ui, sans-serif;
    }

    .image-overlay h1 {
        font-size: 220%;
    }

    .image-overlay p {
        font-size: 100%;
    }

    .services-button {
        background-color: rgb(245, 122, 34);
        padding: 2% 4%;
        border-radius: 4px;
        border: none;
        color: white;
        font-size: 100%;
    }

    .contact-button {
        padding: 2% 4%;
        border-radius: 4px;
        border: none;
        color: black;
        margin: 3% 5%;
        font-size: 100%;
    }

    .header-statement {
        text-align: center;
        margin-top: 3%;
        font-family: ui-sans-serif, system-ui, sans-serif;
    }

    .header-statement h3 {
        font-size: 200%;
    }

    .header-statement p {
        font-size: 100%;
    }

    .services-box {
        text-align: center;
        box-shadow: 0px 5px 5px 2px rgba(0, 0, 0, .2);
        border-radius: 6px;
    }

    .services-box h3 {
        font-size: 80%;
    }

    .services-box p {
        font-size: 60%;
    }

    .services-logo {
        transform: scale(.6);
        padding: 1em 0em;
    }

    .grid-container {
        display: grid;
        grid-template-columns: auto auto auto auto;
        grid-gap: 15px;
        padding: 10px;
        width: 70vw;
        margin: 5% 15vw;
    }

    .grid-container-2 {
        display: grid;
        grid-template-columns: auto;
        grid-gap: 2%;
        padding: 5px;
        width: 70vw;
        margin: 3% 13vw;
    }

    .ewstky-img {
        width: 70vw;
    }

    .ewstky-desc {
        width: 70vw;
        text-align: center;
        margin-top: 5%;
    }

    .ewstky-desc h3 {
        font-size: 300%;
        color: #0e5295;
    }

    .ewstky-desc p {
        font-size: larger;
        width: 75%;
        margin-left: 12%;
    }

}

@media (min-width:1024px) {
    .image-container {
        display: inline-block;
        width: 100%;
        height: 75vh;
        overflow: hidden;
        position: relative;
    }

    .hero-image {
        width: 100%;
        height: 100%;
        object-position: 0% 66%;
        object-fit: cover;
    }

    .image-overlay {
        position: absolute;
        margin-left: 13vw;
        top: 25%;
        text-align: left;
        color: white;
        max-width: 30%;
        padding: 0.5rem 1rem;
        border-radius: 0.5rem;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
        font-family: ui-sans-serif, system-ui, sans-serif;
    }

    .image-overlay h1 {
        font-size: 320%;
    }

    .image-overlay p {
        font-size: 140%;
    }

    .services-button {
        background-color: rgb(245, 122, 34);
        padding: 2% 4%;
        border-radius: 4px;
        border: none;
        color: white;
    }

    .contact-button {
        padding: 2% 4%;
        border-radius: 4px;
        border: none;
        color: black;
        margin: 3% 5%;
    }

    .header-statement {
        text-align: center;
        margin-top: 3%;
        font-family: ui-sans-serif, system-ui, sans-serif;
    }

    .header-statement h3 {
        font-size: 275%;
    }

    .header-statement p {
        font-size: 80%;
    }

    .services-box {
        text-align: center;
        box-shadow: 0px 5px 5px 2px rgba(0, 0, 0, .2);
        border-radius: 6px;
    }

    .services-box h3 {
        font-size: 80%;
    }

    .services-box p {
        font-size: 60%;
    }

    .services-logo {
        transform: scale(.8);
        padding: 1em 0em;
    }

    .grid-container {
        display: grid;
        grid-template-columns: auto auto auto auto;
        grid-gap: 15px;
        padding: 10px;
        width: 70vw;
        margin: 5% 15vw;
    }

    .grid-container-2 {
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 4%;
        padding: 10px;
        width: 70vw;
        margin: 5% 13vw;
    }

    .ewstky-img {
        width: 35vw;
    }

    .ewstky-desc {
        width: 35vw;
        text-align: center;
        margin-top: 20%;
    }

    .ewstky-desc h3 {
        font-size: 300%;
        color: #0e5295;
    }

    .ewstky-desc p {
        font-size: larger;
        width: 75%;
        margin-left: 12%;
    }

}
</style>